import { Phone, Mail, MapPin } from "lucide-react";
import { EMAIL, PHONE, PHONE_TEL } from "../data";

export const Hero = () => (
  <section id="topo" data-testid="hero-section" className="hero">
    <div className="grid-bg" />
    <div className="wrap relative grid lg:grid-cols-12 gap-12 items-center pt-36 pb-24 lg:pt-44 lg:pb-32">
      <div className="lg:col-span-9 reveal">
        <span className="eyebrow" data-testid="hero-location-badge"><MapPin size={14} /> Loures e Grande Lisboa</span>
        <h1 className="font-display uppercase font-extrabold text-5xl sm:text-6xl lg:text-7xl leading-[0.92] mt-6">
          Soluções elétricas<br />
          <span className="text-stroke">e manutenção</span> <span className="text-[var(--blue-2)]">técnica</span>
        </h1>
        <p className="mt-8 text-base md:text-lg text-[var(--muted)] max-w-xl">
          Manutenção industrial <span className="dot" /> Instalações elétricas <span className="dot" /> Automação
        </p>
        <div className="red-rule mt-8" />
        <div className="mt-10 flex flex-wrap gap-4">
          <a href={`tel:${PHONE_TEL}`} data-testid="hero-btn-phone" className="btn btn-red"><Phone size={18} /> Ligar {PHONE}</a>
          <a href={`mailto:${EMAIL}`} data-testid="hero-btn-email" className="btn btn-ghost"><Mail size={18} /> Enviar e-mail</a>
        </div>
      </div>
    </div>
  </section>
);
